import { PaymentFrequency } from '../config/payment-frequency.enum';
import { RegisteredItemProductPaymentMethod } from './registered-item-product-payment-method.interface';

export interface RegisteredItemProductDetails {
  discountedPrice?: number;
  paymentFrequency: PaymentFrequency;
  paymentMethod: RegisteredItemProductPaymentMethod[];
  prepayMonths?: number;
  price: number;
  warrantyProductName: string;
  discountDetails?: {
    discountedPrice: number;
    discountAchCode: string;
    discountCcCode: string;
    discountedMonthsCount: number;
    discountedMonthPercentage: number;
  };
}
